import { render, staticRenderFns } from "./MyGoalsEditModal.vue?vue&type=template&id=dc9505b2"
import script from "./MyGoalsEditModal.vue?vue&type=script&lang=js"
export * from "./MyGoalsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports